// extracted by mini-css-extract-plugin
export default {"bold":"contentText_bold__u-Vch"};